import { render, staticRenderFns } from "./ServicemanItemsReturning.vue?vue&type=template&id=0b00ce65&"
import script from "./ServicemanItemsReturning.vue?vue&type=script&lang=js&"
export * from "./ServicemanItemsReturning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports